const isProduction = process.env.NODE_ENV === 'production' || (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1');
export const BASE_URL = isProduction ? '' : (process.env.REACT_APP_API_URL || 'http://127.0.0.1:5001');

async function request(endpoint: string, options: RequestInit = {}) {
    const token = localStorage.getItem('access_token');
    const isFormData = options.body instanceof FormData;

    const headers: Record<string, string> = {
        ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
        ...((options.headers as Record<string, string>) || {}),
    };

    if (!isFormData && !headers['Content-Type']) {
        headers['Content-Type'] = 'application/json';
    }

    let response: Response;
    try {
        response = await fetch(`${BASE_URL}${endpoint}`, { ...options, headers });
    } catch (networkErr: any) {
        throw new Error('Impossibile connettersi al server. Verificare la connessione o lo stato del backend.');
    }

    if (!response.ok) {
        if (response.status === 401) {
            localStorage.removeItem('access_token');
            localStorage.removeItem('is_admin');
            localStorage.removeItem('user_role');
            window.location.reload();
        }

        let errorMsg = `Errore di comunicazione (${response.status}: ${response.statusText || 'Richiesta fallita'})`;
        try {
            const rawText = await response.text();
            try {
                const errorData = JSON.parse(rawText);
                errorMsg = errorData.message || errorData.error || errorMsg;
            } catch {
                if (response.status === 502) {
                    errorMsg = 'Backend non raggiungibile (502 Bad Gateway). Verificare che il servizio backend (Gunicorn) sia attivo sul server.';
                } else if (response.status === 504) {
                    errorMsg = 'Timeout del server (504 Gateway Timeout). Il backend ha impiegato troppo tempo a rispondere.';
                } else if (response.status === 500) {
                    errorMsg = 'Errore interno del server (500). Verificare i log di sistema del backend.';
                } else if (rawText && rawText.trim().length > 0 && !rawText.includes('<html')) {
                    errorMsg = rawText.trim();
                }
            }
        } catch (_) {}

        throw new Error(errorMsg);
    }

    const rawText = await response.text();
    if (!rawText || rawText.trim().length === 0) {
        return {};
    }

    try {
        return JSON.parse(rawText);
    } catch {
        throw new Error('La risposta del server non è in un formato JSON valido.');
    }
}

export const api = {
    get: (endpoint: string, options?: RequestInit) => request(endpoint, { method: 'GET', ...options }),
    post: (endpoint: string, body: any, options?: RequestInit) => {
        const isFormData = body instanceof FormData;
        return request(endpoint, {
            method: 'POST',
            body: isFormData ? body : JSON.stringify(body),
            ...options
        });
    },
    put: (endpoint: string, body: any, options?: RequestInit) => {
        const isFormData = body instanceof FormData;
        return request(endpoint, {
            method: 'PUT',
            body: isFormData ? body : JSON.stringify(body),
            ...options
        });
    },
    delete: (endpoint: string, options?: RequestInit) => request(endpoint, { method: 'DELETE', ...options }),
    generatePrototypePackage: (cantiereId: number, objectName: string, lprtSerial: string) =>
        api.post(`/user/cantiere/${cantiereId}/object/${objectName}/generate-prototype`, { lprt_serial: lprtSerial }),
};
